import React from "react";
import { useI18n } from "../i18n";
import { Input, Switch, Textarea } from "./ui";
import { digitsOnly, normalizeBranch, validateThaiTaxId } from "../utils/thaiTax";

export const EMPTY_BUYER_TAX = { taxId: "", branchCode: "", taxName: "", taxAddress: "", isJuristic: false };

/** ดึงเฉพาะฟิลด์ภาษีจากแถวลูกค้า (ใช้เป็นค่าเริ่มต้นของฟอร์ม) */
export const buyerTaxOf = (customer) => ({
  taxId: customer?.taxId || "",
  branchCode: customer?.branchCode || "",
  taxName: customer?.taxName || "",
  taxAddress: customer?.taxAddress || "",
  isJuristic: !!customer?.isJuristic,
});

/** ตรวจก่อนบันทึก — คืนข้อความผิดพลาด (ว่าง = ผ่าน) */
export const buyerTaxError = (form) => {
  const taxId = digitsOnly(form.taxId);
  if (form.taxId && !validateThaiTaxId(taxId)) return "เลขประจำตัวผู้เสียภาษีไม่ถูกต้อง (13 หลัก ตรวจ checksum ไม่ผ่าน)";
  if (form.isJuristic && !taxId) return "ลูกค้าเป็นนิติบุคคล ต้องกรอกเลขประจำตัวผู้เสียภาษี";
  if (normalizeBranch(form.branchCode) === null) return "รหัสสาขาต้องเป็นตัวเลขไม่เกิน 5 หลัก (สำนักงานใหญ่ = 00000)";
  return "";
};

/** ค่าที่บันทึกลง customers (เลขล้วน + สาขา 5 หลัก) */
export const cleanBuyerTax = (form) => ({
  taxId: digitsOnly(form.taxId),
  branchCode: normalizeBranch(form.branchCode) || "00000",
  taxName: String(form.taxName || "").trim(),
  taxAddress: String(form.taxAddress || "").trim(),
  isJuristic: !!form.isJuristic,
});

/** ฟิลด์ข้อมูลผู้ซื้อสำหรับออกใบกำกับภาษี — ใช้ทั้งหน้าลูกค้าและฟอร์มเอกสารภาษี */
export default function BuyerTaxFields({ value, onChange, hideNameAddress = false }) {
  const { tx } = useI18n();
  const set = (patch) => onChange({ ...value, ...patch });
  const taxIdBad = value.taxId && !validateThaiTaxId(digitsOnly(value.taxId));
  return (
    <>
      <Switch label={tx("ลูกค้าเป็นนิติบุคคล (ต้องมีเลขผู้เสียภาษี)", "Customer is a juristic person")} checked={!!value.isJuristic} onChange={(checked) => set({ isJuristic: checked })} />
      <div className="grid-2 u-mt-8">
        <Input
          label={tx("เลขประจำตัวผู้เสียภาษี (13 หลัก)", "Tax ID (13 digits)")}
          inputMode="numeric"
          maxLength={13}
          value={value.taxId || ""}
          error={taxIdBad ? tx("เลขไม่ถูกต้อง", "Invalid tax ID") : undefined}
          onChange={(e) => set({ taxId: digitsOnly(e.target.value).slice(0, 13) })}
        />
        <Input
          label={tx("รหัสสาขา (ว่าง = สำนักงานใหญ่ 00000)", "Branch code (blank = HQ 00000)")}
          inputMode="numeric"
          maxLength={5}
          value={value.branchCode || ""}
          onChange={(e) => set({ branchCode: digitsOnly(e.target.value).slice(0, 5) })}
        />
      </div>
      {hideNameAddress ? null : (
        <>
          <Input label={tx("ชื่อสำหรับออกใบกำกับภาษี (ถ้าต่างจากชื่อลูกค้า)", "Name on tax invoice (if different)")} value={value.taxName || ""} onChange={(e) => set({ taxName: e.target.value })} />
          <Textarea label={tx("ที่อยู่สำหรับออกใบกำกับภาษี", "Address on tax invoice")} rows={2} value={value.taxAddress || ""} onChange={(e) => set({ taxAddress: e.target.value })} />
        </>
      )}
    </>
  );
}
